export function validateColumnsNumber(val: number): boolean {
  return val >= 1 && val <= 12;
}
